import { memo, useEffect, useRef, useState } from "react"
import { FeedCurve } from "../../../../Services"
import { frames } from "../../../../Styles"
import { useFeedCurveContext } from "../../../FeedCurves/_FeedCurves/feedCurveContext";
import { TooltipString } from "../../../BaseComponents";

const LabelsComponents = memo(({ feedCurve }: { feedCurve: FeedCurve }) => {
  const context = useFeedCurveContext();  
  const dispatch = context?.dispatch;
  const selectedComponent = context?.state?.component;
  const textRefs = useRef<Record<number, HTMLParagraphElement | null>>({});
  const [overflowMap, setOverflowMap] = useState<Record<number, boolean>>({});
  
  useEffect(() => {
    const newMap: Record<number, boolean> = {};
  
    Object.entries(textRefs.current).forEach(([id, el]) => {
      if (el) {
        newMap[parseInt(id)] = el.scrollWidth > el.clientWidth;
      }
    });
  
    setOverflowMap(newMap);
  }, [feedCurve]);

  if (feedCurve?.components === undefined) return null;

  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", width: "fit-content"}}>
      {feedCurve?.components?.map((feedcurveComponent, index) => {
        const _isHovered = selectedComponent === feedcurveComponent.componentId;
        
        return (
            <div key={feedcurveComponent.componentId} onMouseEnter={() => dispatch({ component: feedcurveComponent.componentId })} onMouseLeave={() => dispatch({ component: undefined })}>
              <TooltipString
                key={feedcurveComponent.componentId}
                tooltipString={overflowMap[feedcurveComponent.componentId] ? feedcurveComponent?.name : undefined}
                contentString={
                  <frames.GridLabel $isHovered={_isHovered} $component={feedcurveComponent?.componentId} $width={"150px"}>
                    <p
                      ref={(el) => { textRefs.current[feedcurveComponent.componentId] = el }}
                      style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}
                    >
                      {feedcurveComponent?.name}
                    </p>
                  </frames.GridLabel>
                }
            />
            </div>
      )})}
    </div>
  )
})

export default LabelsComponents;